import React from 'react';
import { linkifyText, Spacer } from 'src/common';
import { Label, Wrap } from './tableSheets.styles';
import FormulaPreview from 'src/components/FormulaPreview';
import { useFrameworkControlCostFields } from 'src/components/ControlCost';

// Structural type: only the fields the sheet actually renders. Callers pass rows from
// several different queries (and one REST shape), all supersets of this.
export interface ControlLibrarySheetData {
  name?: string | null;
  shortname?: string | null;
  control_identifier?: string | null;
  strategy?: string | null;
  description?: string | null;
  annualCostFormula?: string | null;
  implementationCostFormula?: string | null;
  costNote?: string | null;
  controlFramework?: {
    shortname?: string | null;
    author?: string | null;
    description?: string | null;
  } | null;
}

interface TableSheetControlLibraryProps {
  data: ControlLibrarySheetData;
}

export const TableSheetControlLibrary: React.FC<TableSheetControlLibraryProps> = ({ data }) => {
  const costFields = useFrameworkControlCostFields(data);
  const description = data.description || data.controlFramework?.description;

  return (
    <Wrap>
      <div className="grid grid--2">
        <div>
          <Label>NAME</Label>
          <div className="value" data-cy="sheet-name">
            {data.name}
          </div>
        </div>
        <div>
          <Label>Short Name</Label>
          <div className="value">{data.shortname}</div>
        </div>
      </div>
      <Spacer $px={10} />
      <div>
        <Label>Framework</Label>
        <div className="value">{data.controlFramework?.shortname}</div>
      </div>

      <Spacer $px={10} />
      <div className="grid grid--3">
        <div>
          <Label>Framework Control ID</Label>
          <div className="value">{data.control_identifier}</div>
        </div>
        <div>
          <Label>Strategy</Label>
          <div className="value">{data.strategy}</div>
        </div>
        <div>
          <Label>Author</Label>
          <div className="value">{data.controlFramework?.author}</div>
        </div>
      </div>
      <Spacer $px={10} />
      <Label>DESCRIPTION</Label>
      <div className="value">{description ? linkifyText(description) : null}</div>
      {(costFields?.annualCostFormula || costFields?.implementationCostFormula || costFields?.costNote) && (
        <>
          <Spacer $px={10} />
          <div className="grid grid--2">
            <div>
              <Label>Annual Cost</Label>
              <div className="value">
                {costFields.annualCostFormula ? <FormulaPreview value={costFields.annualCostFormula} /> : '-'}
              </div>
            </div>
            <div>
              <Label>Implementation Cost</Label>
              <div className="value">
                {costFields.implementationCostFormula ? (
                  <FormulaPreview value={costFields.implementationCostFormula} />
                ) : (
                  '-'
                )}
              </div>
            </div>
          </div>
          {costFields.costNote && (
            <>
              <Spacer $px={10} />
              <Label>Cost Note</Label>
              <div className="value">{costFields.costNote}</div>
            </>
          )}
        </>
      )}
    </Wrap>
  );
};
